import {
  FoaPart,
  type BidV2RejectionGroundDto,
} from "../../../../autogen/bff-api";

interface FoaRejectionGroundGroup {
  title: string;
  description: string;
  grounds: BidV2RejectionGroundDto[];
}

export type BidRejectionGroundGroupKind = "mandatory" | "optional";

export interface BidRejectionGroundGroup {
  kind: BidRejectionGroundGroupKind;
  description: string;
  grounds: BidV2RejectionGroundDto[];
}

const SUPPLIER_REJECTION_GROUND_GROUPS: FoaRejectionGroundGroup[] = [
  {
    title: "Del III - FOA § 24-2",
    description: "Anskaffelser etter forskriftens del III",
    grounds: [
      {
        key: "foa-24-2-1-a",
        label: "Oppfyller ikke kvalifikasjonskravene",
        foaReference: "FOA § 24-2 første ledd bokstav a",
        mandatory: true,
      },
      {
        key: "foa-24-2-1-b",
        label:
          "Ikke oppfylt forpliktelser til å betale skatter, avgifter og trygdeavgifter",
        foaReference: "FOA § 24-2 første ledd bokstav b",
        mandatory: true,
      },
      {
        key: "foa-24-2-1-c",
        label:
          "Inhabilitet som ikke kan avhjelpes med mindre inngripende tiltak",
        foaReference: "FOA § 24-2 første ledd bokstav c",
        mandatory: true,
      },
      {
        key: "foa-24-2-1-d",
        label: "Deltatt i forberedelsen og oppnådd urimelig konkurransefordel",
        foaReference: "FOA § 24-2 første ledd bokstav d",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-a",
        label: "Deltakelse i en kriminell organisasjon",
        foaReference: "FOA § 24-2 annet ledd bokstav a",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-b",
        label: "Korrupsjon",
        foaReference: "FOA § 24-2 annet ledd bokstav b",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-c",
        label: "Bedrageri",
        foaReference: "FOA § 24-2 annet ledd bokstav c",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-d",
        label:
          "Terrorhandlinger eller straffbare handlinger med forbindelse til terroraktivitet",
        foaReference: "FOA § 24-2 annet ledd bokstav d",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-e",
        label: "Hvitvasking av penger eller finansiering av terrorisme",
        foaReference: "FOA § 24-2 annet ledd bokstav e",
        mandatory: true,
      },
      {
        key: "foa-24-2-2-f",
        label: "Barnearbeid og andre former for menneskehandel",
        foaReference: "FOA § 24-2 annet ledd bokstav f",
        mandatory: true,
      },
      {
        key: "foa-24-2-3-a",
        label: "Skatter, avgifter og trygdeavgifter i andre tilfeller",
        foaReference: "FOA § 24-2 tredje ledd bokstav a",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-b",
        label:
          "Konkurs, insolvensbehandling, avvikling eller tilsvarende prosess",
        foaReference: "FOA § 24-2 tredje ledd bokstav b",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-c",
        label:
          "Alvorlige eller gjentatte brudd på miljø, arbeidsforhold eller sosiale forhold",
        foaReference: "FOA § 24-2 tredje ledd bokstav c",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-d",
        label: "Interessekonflikt som kan påvirke konkurransen",
        foaReference: "FOA § 24-2 tredje ledd bokstav d",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-e",
        label: "Avtale med hensikt å vri konkurransen",
        foaReference: "FOA § 24-2 tredje ledd bokstav e",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-f",
        label: "Vesentlig mislighold av tidligere offentlig kontrakt",
        foaReference: "FOA § 24-2 tredje ledd bokstav f",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-g",
        label: "Grovt uriktige eller misvisende opplysninger",
        foaReference: "FOA § 24-2 tredje ledd bokstav g",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-h",
        label:
          "Utilbørlig påvirkning eller tilgang til fortrolige opplysninger",
        foaReference: "FOA § 24-2 tredje ledd bokstav h",
        mandatory: false,
      },
      {
        key: "foa-24-2-3-i",
        label: "Alvorlige feil som medfører tvil om yrkesmessig integritet",
        foaReference: "FOA § 24-2 tredje ledd bokstav i",
        mandatory: false,
      },
    ],
  },
  {
    title: "Del II - FOA § 9-5",
    description: "Anskaffelser etter forskriftens del II",
    grounds: [
      {
        key: "foa-9-5-1-a",
        label: "Oppfyller ikke kvalifikasjonskravene",
        foaReference: "FOA § 9-5 første ledd bokstav a",
        mandatory: true,
      },
      {
        key: "foa-9-5-1-b",
        label:
          "Inhabilitet som ikke kan avhjelpes med mindre inngripende tiltak",
        foaReference: "FOA § 9-5 første ledd bokstav b",
        mandatory: true,
      },
      {
        key: "foa-9-5-1-c",
        label: "Deltatt i forberedelsen og oppnådd urimelig konkurransefordel",
        foaReference: "FOA § 9-5 første ledd bokstav c",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-a",
        label: "Deltakelse i en kriminell organisasjon",
        foaReference: "FOA § 9-5 annet ledd bokstav a",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-b",
        label: "Korrupsjon",
        foaReference: "FOA § 9-5 annet ledd bokstav b",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-c",
        label: "Bedrageri",
        foaReference: "FOA § 9-5 annet ledd bokstav c",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-d",
        label:
          "Terrorhandlinger eller straffbare handlinger med forbindelse til terroraktivitet",
        foaReference: "FOA § 9-5 annet ledd bokstav d",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-e",
        label: "Hvitvasking av penger eller finansiering av terrorisme",
        foaReference: "FOA § 9-5 annet ledd bokstav e",
        mandatory: true,
      },
      {
        key: "foa-9-5-2-f",
        label: "Barnearbeid og andre former for menneskehandel",
        foaReference: "FOA § 9-5 annet ledd bokstav f",
        mandatory: true,
      },
      {
        key: "foa-9-5-3-a",
        label: "Skatter, avgifter og trygdeavgifter",
        foaReference: "FOA § 9-5 tredje ledd bokstav a",
        mandatory: false,
      },
      {
        key: "foa-9-5-3-b",
        label:
          "Mangler nødvendig integritet eller kan ikke forventes å gjennomføre kontrakten tilfredsstillende",
        foaReference: "FOA § 9-5 tredje ledd bokstav b",
        mandatory: false,
      },
    ],
  },
];

export const getApplicableRejectionGroundGroups = (
  foaPart?: FoaPart | null,
): BidRejectionGroundGroup[] => {
  const partGroups = getApplicableFoaPartGroups(foaPart);

  return partGroups.flatMap((group) =>
    splitByRejectionType(group.grounds, group.title),
  );
};

const getApplicableFoaPartGroups = (
  foaPart?: FoaPart | null,
): FoaRejectionGroundGroup[] => {
  switch (foaPart) {
    case FoaPart.PartIi:
      return SUPPLIER_REJECTION_GROUND_GROUPS.filter(hasDelIiGrounds);
    case FoaPart.PartIii:
    case FoaPart.PartIv:
      return SUPPLIER_REJECTION_GROUND_GROUPS.filter(hasDelIiiGrounds);
    case undefined:
    case null:
      return SUPPLIER_REJECTION_GROUND_GROUPS;
    case FoaPart.PartI:
    case FoaPart.OutsideFoa:
      return [];
  }
};

const splitByRejectionType = (
  grounds: BidV2RejectionGroundDto[],
  foaTitle: string,
): BidRejectionGroundGroup[] => {
  const groups: BidRejectionGroundGroup[] = [
    {
      kind: "mandatory",
      description: getMandatoryDescription(foaTitle),
      grounds: grounds.filter((ground) => ground.mandatory),
    },
    {
      kind: "optional",
      description: getOptionalDescription(foaTitle),
      grounds: grounds.filter((ground) => !ground.mandatory),
    },
  ];

  return groups.filter((group) => group.grounds.length > 0);
};

const getMandatoryDescription = (foaTitle: string) =>
  foaTitle.includes("24-2")
    ? "FOA § 24-2 første og annet ledd"
    : "FOA § 9-5 første og annet ledd";

const getOptionalDescription = (foaTitle: string) =>
  foaTitle.includes("24-2")
    ? "FOA § 24-2 tredje ledd"
    : "FOA § 9-5 tredje ledd";

const hasDelIiGrounds = (group: FoaRejectionGroundGroup) =>
  group.grounds.some((ground) => ground.key.startsWith("foa-9-5-"));

const hasDelIiiGrounds = (group: FoaRejectionGroundGroup) =>
  group.grounds.some((ground) => ground.key.startsWith("foa-24-2-"));
